export const DEFAULT_MOTION_PLAYBACK_RATE = 2.5;

export const isMotionPlaybackRate = (value) => Number.isFinite(value) && value >= 0.0625 && value <= 16;

export function applyMotionPlaybackRate(element, value) {
  if (!element || !isMotionPlaybackRate(value)) return;
  if (element.defaultPlaybackRate !== value) element.defaultPlaybackRate = value;
  if (element.playbackRate !== value) element.playbackRate = value;
}
